<template lang="pug">
  .component-create-entity-button
    ModalReveal
      a(slot="trigger") Document Requirements
      h2 Requirement {{entity_type}} {{entity_id}}
      DocumentRequirementForm(v-model="body")
      .row.columns.text-center
        ActionButton(:action="save") Add requirement
      hr
      h2 Document Requirements
      loading-spinner(v-if="loading" )
      template(v-if="!loading && requirements.length === 0" )
        h2 Vehicle category has no requirements
      document-requirement(v-for="item in requirements", :item="item" v-if="requirements.length", type="listing", @itemUpdated="loadRequirements")
</template>
<script type="text/babel">
import ModalReveal from '../../foundation/ModalReveal'
import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
import SelectizeDocumentType from '../lists/selectize/SelectizeDocumentType'
import SelectizeCategory from '../lists/selectize/SelectizeCategory'
import SelectizePlan from '../lists/selectize/SelectizePlan'
import SelectizeClientType from "../lists/selectize/SelectizeClientType";
import ActionButton from "../ActionButton";
import RequirementList from "../../../../pages/backoffice/DocumentRequirementList";
import DocumentRequirement from "../../../backoffice/DocumentRequirement";
import LoadingSpinner from "../../LoadingSpinner";
import DocumentRequirementForm from "../../forms/DocumentRequirementForm.vue";

export default {
  name: 'RequirementModal',
  components: {
    DocumentRequirementForm,
    LoadingSpinner,
    DocumentRequirement,
    RequirementList,
    ActionButton, SelectizeClientType, SelectizePlan, SelectizeCategory, SelectizeDocumentType, ModalReveal
  },
  data() {
    return {
      body: {
        entity_type: this.entity_type,
        entity_id: this.entity_id,
        document_type_id: null,
        document_group: null,
        minimum_document_emission_years: null,
        minimum_driver_age: null,
        minimum_driver_registration_seniority: null,
        minimum_bookings_in_last_days: null,
        minimum_client_invoiced: null,
        maximum_client_failed_transactions: null,
      },
      requirements: [],
      loading:false
    }
  },
  created() {
    this.hide = !this.hide
    this.loadRequirements()
  },
  methods: {
    loadRequirements() {
      this.requirements = []
      this.loading = true
      KeplerBackofficeSdk.documentRequirements.list().all((data) => {
        this.requirements = data.filter((item) => {
          return this.entity_id === item.entity.id && this.entity_type === item.entity_class.replace(/App\\Models\\/, '')
        })
        this.loading = false
      })
    },
    save() {
      return KeplerBackofficeSdk.documentRequirements.make(this.body, () => {
        this.$emit('itemUpdated')
        this.loadRequirements()
      })
    }
  },
  props: ['entity_id', 'entity_type'],
  computed: {}
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// RequirementModal.vue?0b80d502